// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__3kThp","title":"styles_title__3CsKr","title_margin_top":"styles_title_margin_top__2OSg-"};